import { clientDetail } from "../shared/clientSummary";

export const ApiConstants = {
  export: {
    fieldList: "/client/json/get-data-json",
    getListing: "/client/export-search/export",
    addList: "/client/search",
    deleteListing: "/client/export-search/export",
    clientList: "/client",
  },
  auth: {
    login: "/asc-auth/login",
    login2: "asc-auth/login",
    authUser: "/asc-auth/auth",
    logout: "asc-auth/auth/:user_id/logout",
    mcpLogin: "/asc-auth/mcp-login",
    mcpHandleCode: "/asc-auth/handle-code",
  },
  split: {
    list: "/case/get-cases",
    splitData: "/case/bulk-copy",
  },
  client: {
    // list: "/asc/api/v1.0/client",
    // detail: "/asc/api/v1.0/client",
    // add: "/asc/api/v1.0/client",
    // update: "/asc/api/v1.0/client",
    listAll: "/client",
    detail: "/client",
    detailByTab: "/client/client-details",
    add: "/client",
    update: "/client",
    delete: "/client/delete/customer",
    deleteSummary: "/client/delete-summary/customer",
    employmentDelete: "/client/delete/employment",
    deleteIdentity: "/client/delete/identity",
    deleteObjective: "/client/delete/objective",
    deleteServiceType: "/client/delete/servicetype",
  },
  extract: {
    getList: "/client/get-locate-and-extract-tree",
    add: "/client/search",
    getExtract: "/client/search",
    applySearch: "/client",
    getClientList: "/client/attribute/value",
    // getExtractbyId:"/client/search"
  },
  vulnerability: {
    add: "/client/vulnerability",
    get: "/client/vulnerability/customer",
    update: "/client/vulnerability",
    getDriver: "/client/vulnerability/driver",
    getCharacteristics: "client/vulnerability/characteristics",
    delete: "client/delete/vulnerability",
  },
  clientUserDefined: {
    add: "/client/userdefined/bulkinsert/value",
    get: "/client/userdefined/value",
    update: "/client/userdefined/bulkupdate/value",
  },

  actionList: {
    list: "/case/actionlist/user",
    listItems: "/case/new/actionlist/user",
    getConsultant: "/case/actionlist/consultant/user",
    getAssignee: "/case/actionlist/assignee/user",
  },
  contactHistory: {
    list: "/case/contact/customer",
  },
  clientActionList: {
    post: "/actionlist/appointment",
    list: "/actionlist/appointment",
  },
  caseActionList: {
    post: "/actionlist/business",
    list: "/actionlist/business",
  },
  report: {
    list: "/report",
  },
  reportList: {
    list: "/report/category?type=Report",
  },
  caseAction: {
    list: "/case/business/customer",
  },
  caseSummaryAsset: {
    list: "/case/asset/casesummary/customer",
  },
  caseSummaryLiability: {
    list: "/case/liability/casesummary/customer",
  },
  caseSummaryList: {
    list: "/case/case-summary/customer",
  },
  commission: {
    addCommission: "/case/commission",
    getCommission: "/case/commission",
    updateCommission: "/case/commission",
    delete: "/case/delete/commission",
    stopReceipt: "/case/commission/stop-receipt",
    getDetail: "/case/commission",
  },
  distribution: {
    add: "/commission/commission-allocation",
    get: "/commission/commission-allocation/commission",
    update: "/commission/commission-allocation",
    getDetail: "/commission/commission-allocation",
  },
  asset: {
    // list: "/asc/api/v1.0/asset",
    list: "/case/asset/customer",
    add: "/case/asset",
    update: "/case/asset",
    getDetail: "/case/asset",
    delete: "case/delete/asset",
  },
  policy: {
    list: "/case/policy/customer",
    add: "/case/policy",
    update: "/case/policy",
    getDetail: "/case/policy",
    delete: "case/delete/policy",
  },
  liability: {
    list: "/case/liability/customer",
    add: "/case/liability",
    update: "/case/liability",
    getDetail: "/case/liability",
    delete: "case/delete/liability",
  },
  outgoings: {
    add: "/assystcashflow/expense",
    list: "/assystcashflow/expense/customer",
    update: "/assystcashflow/expense",
    delete: "assystcashflow/delete/expense",
  },
  income: {
    add: "/assystcashflow/income",
    list: "/assystcashflow/income/customer",
    update: "/assystcashflow/income",
    delete: "/assystcashflow/delete/income",
  },
  dependant: {
    add: "/client",
    list: "client/depentant",
    update: "/client",
    delete: "client/delete/dependant",
  },
  addressBook: {
    add: "/client",
    list: "/client/addressbook/customer",
    update: "/client",
    delete: "client/delete/address",
  },
  attitudeToRisk: {
    add: "/client",
    list: "/client/attituderisk/customer",
    update: "/client",
    delete: "/client/delete/attituderisk",
  },
  clientContacts: {
    clientAction: {
      add: "/client",
      list: "/client/timeallocationbycustomer",
      update: "/client",
      delete: "client/delete/appointment",
    },
    notes: {
      add: "/client/notes",
      list: "/client/notes",
      update: "/client",
      getRecent: "/client/note/notebycustomerid",
      getById: "/client/note",
      delete: "client/delete/note",
    },
    timeAllocation: {
      add: "/client",
      list: "/client/timeallocationbycustomer",
      update: "/client",
      delete: "client/delete/timeallocation",
    },
  },
  clientDocument: {
    getList: "/client/list-of-folders",
    addFolder: "/client/create-folder",
    addDocument: "/client/upload-file",
  },
  fileLink: "/client/document-links/",
  FactFind: {
    add: "/client/notes",
    list: "/client/notes",
    update: "/client",
    delete: "client/delete/note",
  },
  contactClientAction: {
    add: "/client",
    list: "/client/appointmentbycustomer",
    update: "/client/appointment",
    detail: "/client/appointment",
  },
  feesCharges: {
    add: "/client",
    list: "/client/commissionbycustomer/customer",
    update: "/client",
  },
  fund: {
    add: "/case/fund",
    list: "/case/fund",
    update: "/case/fund",
    delete: "case/delete/fund",
    detail: "/case/fund",
  },
  Payments: {
    addPayment: "/case/payments",
    getPayments: "/case/payments/case",
    updatePayment: "/case/payments",
    deletePayment: "case/delete/payment",
  },
  Withdrawals: {
    add: "/case/withdrawal",
    list: "/case/withdrawal/case",
    update: "case/withdrawal",
    delete: "case/delete/withdrawal",
  },
  valuation: {
    addvaluation: "/case/valuation",
    getvaluation: "/case/valuation/case",
    updatevaluation: "/case/valuation",
    delete: "case/delete/valuation",
  },
  Actions: {
    getActions: "/case/business",
    addActions: "/case/business",
    updateActions: "/case/business",
    delete: "case/delete/business",
  },
  notification: {
    add: "/notification/create-template",
    list: "/notification/get-template",
    clientList: "/client/list/all",
    // createContent: "/notification/create-content",
    createContent: "/notification",
    sendEmail: "/notification/create-contents",
    sendBulkEmail: "/user/emailbulk",
    // sendEmail: "/notification/send-email",
    getPreview: "/client/customers",
  },
  credentials: {
    add: "/user/port",
    list: "/user/info",
  },
  emailCredentials: {
    add: "/user/appasswrd",
    // list: "/user/info",
  },
  getDefaultAttitudeToRisk: {
    add: "/client/default/attituderisk",
  },
  getDefaultIncome: {
    add: "/assystcashflow/income/default ",
  },
  getDefaultexpense: {
    add: "/assystcashflow/expense/default ",
  },
  getDefaultobjective: {
    add: "/client/defaultobjectivecategory",
  },
  loadStandardActions: {
    add: "/case/business/default",
    addclientAction: "client/appointment/default",
  },
  getTrackingAction: {
    list: "/masterdata/loadstandard/case",
    listClient: "/masterdata/loadstandard/client",
  },
  exportToExcel: "/asc/api/v1.0/",
  formSettings: "/formSettings",
  userProfile: {
    getDetail: "/user/profile",
    updateDetail: "/user/profile",
  },

  document: "/client/document",
  documentDownload: {
    download: "/document/download",
  },

  systemManager: {
    manageUsers: {
      getPermissions: "/user/auth/roles",
      getUsers: "/user",
      getUserlist: "/user/limit-user",
      createUser: "/user",
      updateUser: "user/:user_id",
      getDetails: "/user/auth/:user_id",
      deleteUser: "user/:user_id",
    },
    commissionType: {
      add: "masterdata/commission/commissiontypes",
      list: "masterdata/commission/commissiontypes",
      update: "masterdata/commission/commissiontypes",
      delete: "masterdata/delete/commission-type",
    },
    commissionRule: {
      add: "masterdata/commission/commissionrule",
      list: "masterdata/commission/commissionrule",
      update: "masterdata/commission/commissionrule",
      delete: "masterdata/delete/commission-rule",
    },
    expenseCategory: {
      add: "masterdata/transactions/expensecategories",
      list: "masterdata/transactions/expensecategories",
      update: "masterdata/transactions/expensecategories",
      delete: "masterdata/delete/Expense-Category",
    },
    incomeCategory: {
      add: "masterdata/transactions/incomecategories",
      list: "masterdata/transactions/incomecategories",
      update: "masterdata/transactions/incomecategories",
      delete: "masterdata/delete/income-category",
    },
    attitudeToRiskcategory: {
      add: "masterdata/attituderisk/categories",
      list: "masterdata/attituderisk/categories",
      update: "masterdata/attituderisk/categories",
      delete: "masterdata/delete/attitude-category",
    },
    attitudeToRiskRating: {
      add: "masterdata/attituderisk/ratings",
      list: "masterdata/attituderisk/ratings",
      update: "masterdata/attituderisk/ratings",
      delete: "masterdata/delete/attitude-rating",
    },
    objectives: {
      add: "masterdata/objectives",
      list: "masterdata/objectives",
      update: "masterdata/objectives",
      delete: "masterdata/delete/objective",
    },
    providers: {
      add: "masterdata/providers",
      list: "masterdata/providers",
      update: "masterdata/providers",
      providerList: "masterdata/providers",
      delete: "masterdata/delete/provider",
    },
    bulkValuation: {
      assystProviderList: "masterdata/assystinvestmentprovider",
      assystDataProviderList: "masterdata/assystdataproviders",
      updateBulkValuation: "masterdata/valuationupdateprovider",
    },
    errorLog: {
      list: "case/get-valuation-update-history",
    },
    userDefined: {
      add: "masterdata/userdefined/field",
      list: "masterdata/userdefined/field",
      update: "masterdata/userdefined/field",
      delete: "masterdata/userdefined/field/delete",
    },
    loadTrackingAction: {
      add: "masterdata/standardtracking",
      list: "masterdata/standardtracking/case",
      update: "masterdata/standardtracking",
      listClient: "masterdata/standardtracking/client",
      listCaseAction: "masterdata/standardtracking/case",
      delete: "masterdata/delete/tracking",
    },
    companyDetails: {
      get: "masterdata/company-profile",
      update: "masterdata/company-profile",
      // Write-only — reading existing SMTP settings stays on the
      // pre-existing user/info (-> user service's smtp/find) call, per the
      // architecture doc's explicit "not moved: findSmtpServers" decision.
      saveSmtp: "masterdata/company-profile/smtp",
    },
  },
  selectionList: {
    getOptions: "/masterdata/option",
    addOptions: "/masterdata/option",
  },
  templates: {
    upload: "masterdata/document/templateupload",
    template: "report/new",
    list: "report/getAllTemplates",
    letterList: "report/Letter/getTemplatesByType",
    emailList: "report/Email/getTemplatesByType",
    deleteLetter: "masterdata",
    deleteEmail: "masterdata",
    letterGeneration: "report/new/custom",
    emailGeneration: "report/new/custom",
    sampleLetter: "report/sample/getAllSampleTemplates",
    sampleEmail: "report/sample/getAllSampleTemplates",

    edit: "masterdata/update/",
  },
  commissionModule: {
    commissionClient: {
      add: "/client/create_commission",
      list: "/client/commission",
      update: "/client/update_commission",
    },
    receipting: {
      list: "case/commission-receipt/user",
      add: "case/commission-receipt",
    },
    distribution: {
      list: "commission/allocation/list",
      add: "commission/distribute-commission/payout",
      stop: "commission/commission-allocation/stop",
      getDetail: "/commission/commission-allocation",
    },
  },
  fees_Changes: {
    list: "case/fees-charges/user",
    assign_case: "case/fees-charges/associated-case/customer",
  },
  fileUpload: {
    upload: "document/files/upload",
    scanStatus: "document/files/scan-status",
    finalize: "document/files/finalize",
  },
  orchestration: {
    jobs: "/orchestration/jobs",
    documentDownload: "/document/download",
    lettersGenerate: "/orchestration/letters/generate",
    bulkValuationElevateGenerate: "/orchestration/bulk-valuation/elevate/generate",
    bulkValuationUploadProviders: "/orchestration/bulk-valuation/upload-providers",
  },
  case: {
    asset: "case/asset/customer",
    liability: "case/liability/customer",
    policy: "case/policy/customer",
  },
  commissionStatement: {
    statements: "commission/commission-receipt/commission-statements",
    uploadCommissionStatement:
      "commission/commission-receipt/upload-commission-statement",
    batchV14: "commission/commission-receipt/commission-statement",
  },
  cashCalc: {
    credentials: {
      list: "v1/cashcalc/credentials",
      upsert: "v1/cashcalc/credentials",
      delete: "v1/cashcalc/credentials",
    },
    oauth: {
      authorizeUrl: "v1/cashcalc/oauth/authorize-url",
      token: "v1/cashcalc/oauth/token",
      connectionStatus: "v1/cashcalc/oauth/connection-status",
      disconnect: "v1/cashcalc/oauth/disconnect",
    },
    sync: "v1/cashcalc/sync",
    validate: "v1/cashcalc/validate",
  },
  transact: {
    // Generic {provider}-parameterized base — the provider code (e.g.
    // "transact") is appended per-call so the UI is never hardcoded to one
    // integration. See service/index.ts's transact.* methods.
    base: "masterdata/integrations/bulk-valuation",
  },
  frnDetails: {
    list: "masterdata/system-manager/tenant-frns",
    setStatus: "masterdata/system-manager/tenant-frns",
  },
};

export const UserPermissionsList = {
  ALLOW_VIEW_CLIENT: "allow-view-client",
  ALLOW_ADD_CLIENT: "allow-add-client",
  VIEW_ALL_CLIENT: "view-all-client",
  ALLOW_RESTRICTED_CLIENT: "allow-restricted-client",
  ALLOW_UPDATE_CLIENT: "allow-update-client",
  LIMIT_CLIENTS_FOR_USER: "limit-clients-for-user",
  ALLOW_DELETE_CLIENT: "allow-delete-client",
  ALLOW_CLIENT_REPORTS: "allow-client-reports",
  ALLOW_REASSIGN_ACTIONS: "allow-reassign-actions",
  ALLOW_CLIENT_UPLOADS: "allow-client-uploads",
  ALLOW_CLIENT_EXPORTS: "allow-client-exports",
  ALLOW_ADD_USER: "allow-add-user",
  ALLOW_UPDATE_USER: "allow-update-user",
  ALLOW_VIEW_USER: "allow-view-user",
  ALLOW_DELETE_USER: "allow-delete-user",
  ALLOW_UPDATE_MASTER_DATA: "allow-update-master-data",
  ALLOW_COMMISSION_RECEIPTING: "allow-commission-receipting",
  ALLOW_ADD_DISTRIBUTION: "allow-add-distribution",
  ALLOW_UPDATE_DISTRIBUTION: "allow-update-distribution",
  ALLOW_COMMISSION_DISTRIBUTION: "allow-commission-distribution",
  ALLOW_COMMISSION_REPORTS: "allow-commission-reports",
  ALLOW_BUSINESS_REPORTS: "allow-business-reports",
  ALLOW_UPDATE_COMMISSION_MASTER: "allow-update-commission-master",
};

export const apiUrls = {
  CUSTOMER_BASE_URL: "https://dev-middleware.assyst.cloud/",
  // CUSTOMER_BASE_URL: "https://qa-middleware.assyst.cloud/",
  // CUSTOMER_BASE_URL: "http://localhost:4000/",
};
